import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Card, Table } from 'react-bootstrap';
import { Pagination } from '../../../shared/components/Pagination';
import EmptyState from '../../../shared/components/EmptyState';
import TableSkeleton, { ITableColumn } from '../../../shared/components/TableSkeleton';
import { ICampaignsBudgetRanges } from '../../../model/campaign/ICampaignsBudgetRanges';
import { CampaignsService } from '../CampaignsService';
import { ErrorToast } from '../../../utils/toasters';
import { numberFormatter } from '../../../utils/helpers/NumberFormater';

const BUDGET_RANGE_COLUMNS: ITableColumn[] = [
    { label: 'Platforms' },
    { label: 'Min price' },
    { label: 'Max price' },
    { label: 'Recommended min budget' },
    { label: 'Recommended max budget' },
    { label: 'Creator type' },
    { label: 'Action' },
];

export function CampaignBudgetRange() {
    const navigate = useNavigate();
    const [state, setState] = useState({
        page: 1,
        perPage: 20,
        title: '',
    });

    const [campaignBudget, setCampaignBudget] = useState<ICampaignsBudgetRanges[]>([]);
    const [change, setChange] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [dataLoading, setDataLoading] = useState(true);

    const handlePages = (updatePage: number) => {
        setState({ ...state, page: updatePage });
        setPage(updatePage);
    };

    useEffect(() => {
        setDataLoading(true);
        CampaignsService.getBudgetsRanges(state)
            .then(data => {
                setCampaignBudget(data.data);
                setTotalPages(Math.ceil(data.count / state.perPage));
            })
            .catch(err => ErrorToast(err))
            .finally(() => setDataLoading(false));
    }, [page, change]);

    return (
        <>
            <Button variant="outline-primary" onClick={() => navigate('/campaign/budget-range/form/')}>
                + Add campaign budget range
            </Button>
            <Card className="mt-5 mb-5 p-4">
                {dataLoading ? (
                    <TableSkeleton columns={BUDGET_RANGE_COLUMNS} rows={state.perPage} />
                ) : (
                    <>
                        <Table hover responsive>
                            <thead>
                                <tr>
                                    {BUDGET_RANGE_COLUMNS.map(column => (
                                        <th key={column.label} className={column.className}>
                                            {column.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {campaignBudget.map(budget => (
                                    <tr key={budget.id}>
                                        <td>{budget.nbPlatforms}</td>
                                        <td>{numberFormatter(budget.minPrice)}</td>
                                        <td>{numberFormatter(budget.maxPrice)}</td>
                                        <td>{numberFormatter(budget.recommendedMinBudget)}</td>
                                        <td>{numberFormatter(budget.recommendedMaxBudget)}</td>
                                        <td>{budget.creatorType?.title ?? '-'}</td>
                                        <td>
                                            <Button
                                                className="mr-2"
                                                onClick={() => navigate(`/campaign/budget-range/form/${budget.id}`)}
                                            >
                                                Edit
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        {campaignBudget.length === 0 && <EmptyState classHolder="shadow-none" />}
                    </>
                )}

                <Pagination page={page} totalPages={totalPages} handlePagination={handlePages} disabled={dataLoading} />
            </Card>
        </>
    );
}
